import gql from "graphql-tag";

export default function query(params) {
    return gql`
            mutation {
                createSaltoGateway(
                    device_id: "${params.device_id}"
                    gwid: "${params.gwid}"
                ) {
                    errors
                    gateway {
                        id
                        device_id
                        garage_id
                        master_id
                        type
                        gwid
                        note
                        created_at
                        updated_at
                        deleted_at
                        garage_gateway {
                            name
                            id
                            state
                            echarger
                        }
                    }
                }
            }`;
}
